import { Navigate } from "react-router-dom";
import { store } from "../Redux/app/store";
import { savePartnerData, savePartnerProfileData } from "../Redux/Slices/MainSlice";
import httpApiCall from "./api.service";
import * as XLSX from "xlsx";
import md5 from 'md5';

export const countryWiseRegex: any = {
    US: {
      regex: /(\d{3})(\d{3})(\d{4})/g,
      group: '$1-$2-$3'
    },
    CA: {
      regex: /(\d{3})(\d{3})(\d{4})/g,
      group: '$1-$2-$3'
    },
    GB: {
      regex:  /(\d{4})(\d{5})/g,
      group: '$1 $2'
    },
    AU: {
      regex: /(\d{1})(\d{4})(\d{4})/g,
      group: '$1 $2 $3'
    },
    NZ: {
      regex: /(\d{1})(\d{4})(\d{4})/g,
      group: '$1 $2 $3'
    },
    DE: {
      regex: /(\d{4})(\d{7})/g,
      group: '$1 $2'
    },
    IT: {
      regex: /(\d{3})(\d{7})/g,
      group: '$1 $2'
    },
    FR: {
      regex: /(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})/g,
      group: '$1 $2 $3 $4 $5'
    },
    ES: {
      regex: /(\d{3})(\d{6})/g,
      group: '$1 $2'
    },
    PL: {
      regex: /(\d{3})(\d{3})(\d{3})/g,
      group: '$1 $2 $3'
    },
    JP: {
      regex: /(\d{2})(\d{4})(\d{4})/g,
      group: '$1 $2 $3'
    },
};
export const Regex = {
    name: /^(?=.*[a-zA-Z])[^0-9]+$/,
    password_max_password_length: 30,
    password_min_password_length: 8,
    password_pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])(?!.*\s)[A-Za-z\d\W_]{8,30}$/,
    email : /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    phoneRegExp : /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
    bioMaxLimit: 300,
    bioMinLimit: 150
}
export function setStorageKey(key: any, value: any) {
    const data = localStorage.getItem('partner_storage');
    let storage = data ? JSON.parse(data) : {};
    if (storage && Object.keys(storage).length) {
        storage[key] = value;
        localStorage.setItem('partner_storage', JSON.stringify(storage));
    } else {
        const partner_storage: any = {};
        partner_storage[key] = value;
        localStorage.setItem('partner_storage', JSON.stringify(partner_storage));
    }
}

export function clearPartnerStorage() {
    if (localStorage.getItem('partner_storage')) {
        localStorage.removeItem('partner_storage')
    } else {
        localStorage.setItem('partner_storage', JSON.stringify({}));
    }
    window.location.reload();
}

export function getStorageValue(key: any) {
    const data = localStorage.getItem('partner_storage');
    let storage = data ? JSON.parse(data) : {};
    if (storage) {
        return storage[key];
    }
}

export function setLoginData(data: any, login: any, navigate: any  = true) {
    if (data.access_token) {
        setStorageKey('partnerToken', data.access_token);
    }
    if (data.partner_profile) {
        setStorageKey('partnerProfile', data.partner_profile);
    }
    if (data.user_partner_info && data.user_partner_info.pu_id) {
      setStorageKey("partner_user_data", {
        pu_id: data.user_partner_info.pu_id
      });
    }
    if (navigate) {
        if (login == 1 || login == 2) {
            // redirect to dashboard  
        } else if (login == 'switch') {
            window.location.reload();
        }
        // store.dispatch(loginDataReducer(data));
        // setTimeout(() => {
        //     <Link to="/app/dashboard" replace={true} />
        // })
    }
}

export function utc_to_local(a: any) {
    if (a == null) return '';
    let local = '';
    var t = a.split('T');
    if (t[1] == '') {
        return a;
    }
    if (a.indexOf('T') < 0) return a;
    var aD = t[0].split('-');
    local = '' + aD[1] + '-' + aD[2] + '-' + aD[0];
    return local;
};

// Get Avg. contracts financed, Financed-amount
export function financedAvg(number: any, date_registered: any) {
    var a = new Date(date_registered);
    var b = new Date();
    // Months between years.
    var months = (b.getFullYear() - a.getFullYear()) * 12;
    months += b.getMonth() - a.getMonth();
    var totalAvgContract;
    if (months == 0) {
        totalAvgContract = number / 1;
    } else {
        totalAvgContract = number / months;
    }

    if (totalAvgContract > 1) {
        var rounAvgContract = Math.round(totalAvgContract)
        return rounAvgContract.toLocaleString();
    } else {
        return Math.round(totalAvgContract * 100) / 100;
    }
};

// Get Avg.  Interest-rate, Down-Payment
export function getAvgInterestRate(number: any, number_of_Contract: any) {
    if (number && number != null) {
        var totalAvg = number / number_of_Contract;
        if (totalAvg > 1) {
            return Math.round(totalAvg);
        } else {
            return Math.round(totalAvg * 100) / 100;
        }
    } else {
        return 0;
    }

};

export function getLanguage(key: any, lan_code: any) {
    if (key && lan_code) {
        return languageFormatted[lan_code][key];
    }
};

export const languageFormatted: any = {
    en: {
        bank_business_info: "Bank is not added yet. Business Information is not added yet",
        first_contract_date: "First Contract Date",
        last_contract_date: "Last Contract Date",
        completed: "Completed",
        date_registered: 'Registration Date',
        agent_name: 'Agent Name',
        email: 'Email',
        total_sales_made: 'Total Sale',
        added_by: 'Added By',
        sale_date: 'Sale Date',
        avg_usage_rate: 'Avg Usage Rate',
        agent_percentage: 'Percentage',
        stripe_account_id: 'Registration Status',
        note: 'Notes',
        doctor_code: ' Code',
        doctor_title: 'Salutation',
        doctor_first_name: 'First Name',
        doctor_last_name: 'Last Name',
        mobile: 'Mobile',
        ind_name: 'Industry',
        speciality_name: 'Sub Industry',
        ind_is_guaranteed: 'Protected Status',
        date_of_birth: 'Date of Birth',
        practice_name: ' Name',
        practice_address: ' Address',
        total_number_of_contracts: 'Total Contracts',
        contract_date: 'Contract Date',
        avg_contract_financed_per_month: 'Avg Payment Plans Per Month',
        avg_financed_amount: 'Avg. Payment Plans Amount Per Month',
        avg_interest_rate: 'Avg. Interest Rate',
        avg_down_payment: 'Avg. Down Payment',
        avg_term: 'Avg. Term',
        is_blocked: 'Blocked',
        bank_stripe_account_id: 'Bank',
        share_form: 'Share from',
        months: 'month(s)',
        guaranteed: 'Protected',
        non_guaranteed: 'Non-Protected',
        yes: "Yes",
        no: "No",
        business_owner_name: 'Business Owner Name',
        transaction_date: "Transaction Date",
        payment_type: "Payment Type",
        commission_amount: "Commission Amount",
        "Credee Fee + Upfront Payment": "Credee Fee + Upfront Payment",
        "Credee Fee + Down Payment + Upfront Payment": "Credee Fee + Down Payment + Upfront Payment",
        "Down Payment + Upfront Payment": "Down Payment + Upfront Payment",
        "First Recurring Payment": "First Recurring Payment",
        "Reverse From Partner": "Reverse From Partner",
        "Protected Payment": "Protected Payment",
        "Recurring Payment": "Recurring Payment",
        "Credee Fee + Down Payment": "Credee Fee + Down Payment",
        "Business Owner": "Business Owner",
        "Customer": "Customer",
        "Service": "Service",
        "Business": "Business",
        "Sub Industry": "Sub Industry",
        "Start Date": "Start Date",
        "End Date": "End Date",
        "Total Payment": "Total Payment",
        "Payout Details": "Payout Details",
        "Payout Info": "Payout Info",
        "Contract ID": "Contract ID",
        "Payment Amount": "Payment Amount",
        "Payment Status": "Payment Status",
        "Amount": "Amount",
        "Arrival Date": "Arrival Date",
        'Total number of contracts': "Total number of contracts",
        'Sub Partner Name': 'Sub Partner Name',
        pending: 'pending',
        total_earning: 'Total earnings',
        total_upcoming_earnings: 'Total upcoming earnings'
    },
    fr: {
        bank_business_info: "La banque n'est pas encore ajoutée. Les informations commerciales ne sont pas encore ajoutées",
        first_contract_date: "Date du premier contrat",
        last_contract_date: "Date du dernier contrat",
        completed: "Complété",
        date_registered: "Date d'inscription",
        agent_name: "Nom d'agent",
        email: "E-mail",
        total_sales_made: "Vente totale",
        added_by: 'Ajouté par',
        sale_date: 'Date de vente',
        avg_usage_rate: "Taux d'utilisation moyen",
        agent_percentage: 'Pourcentage',
        stripe_account_id: "Statut d'enregistrement",
        note: 'Remarques',
        doctor_code: ' Code',
        doctor_title: 'Salutation',
        doctor_first_name: 'Prénom',
        doctor_last_name: 'Nom de famille',
        mobile: 'Mobile',
        ind_name: 'Industrie',
        speciality_name: 'Sous-industrie',
        ind_is_guaranteed: 'Statut Protégée',
        date_of_birth: 'Date de naissance',
        practice_name: ' Nom',
        practice_address: ' Adresse',
        total_number_of_contracts: 'Total des contrats',
        contract_date: 'Date de contrat',
        avg_contract_financed_per_month: 'Plans de paiement moyens par mois',
        avg_financed_amount: 'Moy. Montant des échéanciers de paiement par mois',
        avg_interest_rate: "Moy. Taux d'intérêt",
        avg_down_payment: 'Moy. Acompte',
        avg_term: 'Moy. Terme',
        is_blocked: 'Bloquée',
        bank_stripe_account_id: 'Banque',
        share_form: 'Partager depuis',
        months: 'mois',
        guaranteed: 'Protégée',
        non_guaranteed: 'Non Protégée',
        yes: "Oui",
        no: "Non",
        business_owner_name: "Nom du propriétaire de l'entreprise",
        transaction_date: "Date de la transaction",
        payment_type: "Type de paiement",
        commission_amount: "Montant de la commission",
        "Credee Fee + Upfront Payment": "Frais de crédit + paiement initial",
        "Credee Fee + Down Payment + Upfront Payment": "Frais de crédit + acompte + paiement initial",
        "Down Payment + Upfront Payment": "Acompte + paiement initial",
        "First Recurring Payment": "Premier paiement récurrent",
        "Reverse From Partner": "Inverser du partenaire",
        "Protected Payment": "Paiements protégés",
        "Recurring Payment": "Paiement récurrent",
        "Credee Fee + Down Payment": "Frais de crédit + acompte",
        "Business Owner": "Propriétaire d'entreprise",
        "Customer": "Client",
        "Service": "Service",
        "Business": "Entreprise",
        "Sub Industry": "Sous-industrie",
        "Start Date": "Date de début",
        "End Date": "Date de fin",
        "Total Payment": "Paiement total",
        "Payout Details": "Détails du paiement",
        "Payout Info": "Informations de paiement",
        "Contract ID": "Numéro de contrat",
        "Payment Amount": "Montant du paiement",
        "Payment Status": "Statut de paiement",
        "Amount": "Montante",
        "Arrival Date": "Date d'arrivée",
        'Sub Partner Name': 'Nom du sous-partenaire',
        pending: 'en attente'
    },
    de: {
        bank_business_info: "Bank wurde noch nicht hinzugefügt. Geschäftsinformationen wurden noch nicht hinzugefügt",
        first_contract_date: "Erstes Vertragsdatum",
        last_contract_date: "Letztes Vertragsdatum",
        completed: "Vollendet",
        date_registered: "Registrierungsdatum",
        agent_name: "Agentenname",
        email: "Email",
        total_sales_made: "Ausverkauf",
        added_by: 'Hinzugefügt von',
        sale_date: 'Verkaufsdatum',
        avg_usage_rate: 'Durchschnittliche Nutzungsrate',
        agent_percentage: 'Prozentsatz',
        stripe_account_id: 'Registrationsstatus',
        note: 'Anmerkungen',
        doctor_code: ' Code',
        doctor_title: 'Anrede',
        doctor_first_name: 'Vorname',
        doctor_last_name: 'Familienname, Nachname',
        mobile: 'Handy',
        ind_name: 'Industrie',
        speciality_name: 'Unterindustrie',
        ind_is_guaranteed: 'Geschützt Status',
        date_of_birth: 'Geburtsdatum',
        practice_name: ' Name',
        practice_address: ' Adresse',
        total_number_of_contracts: 'Gesamtverträge',
        contract_date: 'Vertragsdatum',
        avg_contract_financed_per_month: 'Durchschnittliche Zahlungspläne pro Monat',
        avg_financed_amount: 'Durchschn. Zahlungsplanbetrag pro Monat',
        avg_interest_rate: 'Durchschn. Zinsrate',
        avg_down_payment: 'Durchschn. Anzahlung',
        avg_term: 'Durchschn. Begriff',
        is_blocked: 'verstopft',
        bank_stripe_account_id: 'Bank',
        share_form: 'Geteilt von',
        months: 'Monate',
        guaranteed: 'Geschützt',
        non_guaranteed: 'Nicht Geschützt',
        yes: "Ja",
        no: "NEIN",
        business_owner_name: 'Name des Geschäftsinhabers',
        transaction_date: "Transaktionsdatum",
        payment_type: "Zahlungsart",
        commission_amount: "Provisionsbetrag",
        "Credee Fee + Upfront Payment": "Credee-Gebühr + Vorauszahlung",
        "Credee Fee + Down Payment + Upfront Payment": "Credee-Gebühr + Anzahlung + Vorauszahlung",
        "Down Payment + Upfront Payment": "Anzahlung + Vorauszahlung",
        "First Recurring Payment": "Erste wiederkehrende Zahlung",
        "Reverse From Partner": "Umkehrung vom Partner",
        "Protected Payment": "Geschützte Zahlung",
        "Recurring Payment": "Wiederkehrende Zahlung",
        "Credee Fee + Down Payment": "Credee-Gebühr + Anzahlung",
        "Business Owner": "Geschäftsinhaber",
        "Customer": "Kunde",
        "Service": "Service",
        "Business": "Geschäft",
        "Sub Industry": "Unterindustrie",
        "Start Date": "Startdatum",
        "End Date": "Endtermin",
        "Total Payment": "Gesamtzahlung",
        "Payout Details": "Auszahlungsdetails",
        "Payout Info": "Auszahlungsinformationen",
        "Contract ID": "Vertrags-ID",
        "Payment Amount": "Zahlungsbetrag",
        "Payment Status": "Zahlungsstatus",
        "Amount": "Menge",
        "Arrival Date": "Ankunftsdatum",
        'Sub Partner Name': 'Name des Unterpartners',
        pending: 'ausstehend'
    },
    it: {
        bank_business_info: "La banca non è stata ancora aggiunta. Le informazioni aziendali non sono state ancora aggiunte",
        first_contract_date: "Prima data del contratto",
        last_contract_date: "Data dell'ultimo contratto",
        completed: "Completato",
        date_registered: 'Data di registrazione',
        agent_name: "Nome dell'agente",
        email: 'E-mail',
        total_sales_made: 'Vendita totale',
        added_by: 'Aggiunto da',
        sale_date: 'Data di vendita',
        avg_usage_rate: 'Tasso di utilizzo medio',
        agent_percentage: 'Percentuale',
        stripe_account_id: 'Stato della registrazione',
        note: 'Appunti',
        doctor_code: ' Codice',
        doctor_title: 'Saluto',
        doctor_first_name: 'Nome di battesimo',
        doctor_last_name: 'Cognome',
        mobile: 'Mobile',
        ind_name: 'Industria',
        speciality_name: 'Sottoindustria',
        ind_is_guaranteed: 'Stato Protetta',
        date_of_birth: 'Data di nascita',
        practice_name: ' Nome',
        practice_address: ' Indirizzo',
        total_number_of_contracts: 'Contratti totali',
        contract_date: 'Data del contratto',
        avg_contract_financed_per_month: 'Piani di pagamento medi al mese',
        avg_financed_amount: 'Media Importo dei piani di pagamento al mese',
        avg_interest_rate: "Media Tasso d'interesse",
        avg_down_payment: 'Media Acconto',
        avg_term: 'Media Termine',
        is_blocked: 'Bloccata',
        bank_stripe_account_id: 'Banca',
        share_form: 'Condividi da',
        months: 'mesi',
        guaranteed: 'Protetta',
        non_guaranteed: 'Non Protetta',
        yes: "SÌ",
        no: "No",
        business_owner_name: "Nome del titolare dell'azienda",
        transaction_date: "Data della transazione",
        payment_type: "Modalità di pagamento",
        commission_amount: "Importo della commissione",
        "Credee Fee + Upfront Payment": "Commissione del creditore + Pagamento anticipato",
        "Credee Fee + Down Payment + Upfront Payment": "Commissione del creditore + Acconto + Pagamento anticipato",
        "Down Payment + Upfront Payment": "Acconto + Pagamento anticipato",
        "First Recurring Payment": "Primo pagamento ricorrente",
        "Reverse From Partner": "Storna dal partner",
        "Protected Payment": "Pagamento protetto",
        "Recurring Payment": "Pagamento ricorrente",
        "Credee Fee + Down Payment": "Commissione del creditore + acconto",
        "Business Owner": "Imprenditore",
        "Customer": "Cliente",
        "Service": "Servizio",
        "Business": "Attività commerciale",
        "Sub Industry": "Sottoindustria",
        "Start Date": "Data d'inizio",
        "End Date": "Data di fine",
        "Total Payment": "Pagamento totale",
        "Payout Details": "Dettagli del pagamento",
        "Payout Info": "Informazioni sul pagamento",
        "Contract ID": "Identificativo del contratto",
        "Payment Amount": "Importo del pagamento",
        "Payment Status": "Stato del pagamento",
        "Amount": "Quantità",
        "Arrival Date": "Data d'arrivo",
        'Sub Partner Name': 'Nome del partner secondario',
        pending: 'in attesa di'
    },
    es: {
        bank_business_info: "El banco aún no está agregado. La información comercial aún no se ha agregado",
        first_contract_date: "Fecha del primer contrato",
        last_contract_date: "Fecha del último contrato",
        completed: "Terminada",
        date_registered: 'Fecha de Registro',
        agent_name: 'Nombre de la agente',
        email: 'Correo electrónico',
        total_sales_made: 'Venta total',
        added_by: 'Añadido por',
        sale_date: 'Fecha de venta',
        avg_usage_rate: 'Tasa de uso promedio',
        agent_percentage: 'Porcentaje',
        stripe_account_id: 'estado de registro',
        note: 'Notas',
        doctor_code: ' Código',
        doctor_title: 'Saludo',
        doctor_first_name: 'Nombre de pila',
        doctor_last_name: 'Apellido',
        mobile: 'Móvil',
        ind_name: 'Industria',
        speciality_name: 'Subindustria',
        ind_is_guaranteed: 'Estado Protegida',
        date_of_birth: 'Fecha de nacimiento',
        practice_name: ' Nombre',
        practice_address: ' DIRECCIÓN',
        total_number_of_contracts: 'Contratos totales',
        contract_date: 'Fecha del contrato',
        avg_contract_financed_per_month: 'Planes de pago promedio por mes',
        avg_financed_amount: 'Promedio Monto de los planes de pago por mes',
        avg_interest_rate: 'Promedio Tasa de interés',
        avg_down_payment: 'Promedio Depósito',
        avg_term: 'Promedio Término',
        is_blocked: 'Obstruida',
        bank_stripe_account_id: 'Banco',
        share_form: 'Compartir desde',
        months: 'meses',
        guaranteed: 'Protegida',
        non_guaranteed: 'No Protegida',
        yes: "Sí",
        no: "No",
        business_owner_name: 'Nombre del propietario del negocio',
        transaction_date: "Fecha de Transacción",
        payment_type: "Tipo de pago",
        commission_amount: "Monto de la comisión",
        "Credee Fee + Upfront Payment": "Tarifa de crédito + Pago inicial",
        "Credee Fee + Down Payment + Upfront Payment": "Tarifa de crédito + Pago inicial + Pago inicial",
        "Down Payment + Upfront Payment": "Pago inicial + Pago inicial",
        "First Recurring Payment": "Primer pago recurrente",
        "Reverse From Partner": "Reversa de socio",
        "Protected Payment": "Pago protegido",
        "Recurring Payment": "Pago recurrente",
        "Credee Fee + Down Payment": "Tarifa de crédito + pago inicial",
        "Business Owner": "Dueño de negocio",
        "Customer": "Cliente",
        "Service": "Servicio",
        "Business": "Negocio",
        "Sub Industry": "Subindustria",
        "Start Date": "Fecha de inicio",
        "End Date": "Fecha final",
        "Total Payment": "Pago total",
        "Payout Details": "Detalles de pago",
        "Payout Info": "Información de pago",
        "Contract ID": "ID de contrato",
        "Payment Amount": "Monto del pago",
        "Payment Status": "Estado de pago",
        "Amount": "Cantidad",
        "Arrival Date": "Fecha de llegada",
        'Sub Partner Name': 'Nombre del subsocio',
        pending: 'pendiente'
    },
    pl: {
        bank_business_info: "Bank nie został jeszcze dodany. Informacje biznesowe nie zostały jeszcze dodane",
        first_contract_date: "Pierwsza data umowy",
        last_contract_date: "Ostatnia data zawarcia umowy",
        completed: "Zakończony",
        date_registered: 'Data rejestracji',
        agent_name: 'Imię agenta',
        email: 'E-mail',
        total_sales_made: 'Całkowita sprzedaż',
        added_by: 'Dodane przez',
        sale_date: 'Data wyprzedaży',
        avg_usage_rate: 'Średni współczynnik wykorzystania',
        agent_percentage: 'Odsetek',
        stripe_account_id: 'status rejestracji',
        note: 'Notatki',
        doctor_code: ' Kod',
        doctor_title: 'Pozdrowienie',
        doctor_first_name: 'Imię',
        doctor_last_name: 'Nazwisko',
        mobile: 'mobilny',
        ind_name: 'Przemysł',
        speciality_name: 'Podprzemysł',
        ind_is_guaranteed: 'Chroniony status',
        date_of_birth: 'Data urodzenia',
        practice_name: ' Nazwa',
        practice_address: ' Adres',
        total_number_of_contracts: 'Razem kontrakty',
        contract_date: 'Data zamówienia',
        avg_contract_financed_per_month: 'Średnie plany płatności miesięcznie',
        avg_financed_amount: 'Śr. Kwota planów płatności miesięcznie',
        avg_interest_rate: 'Śr. Oprocentowanie',
        avg_down_payment: 'Śr. Zaliczka',
        avg_term: 'Śr. Termin',
        is_blocked: 'Zablokowany',
        bank_stripe_account_id: 'Bank',
        share_form: 'Udostępnij z',
        months: 'miesiące',
        guaranteed: 'Chroniony',
        non_guaranteed: 'Niechroniony',
        yes: "Tak",
        no: "NIE",
        business_owner_name: 'Imię i nazwisko właściciela firmy',
        transaction_date: "Data dokonania transakcji",
        payment_type: "Typ płatności",
        commission_amount: "Kwota prowizji",
        "Credee Fee + Upfront Payment": "Opłata Credee + Płatność z góry",
        "Credee Fee + Down Payment + Upfront Payment": "Opłata Credee + Zaliczka + Płatność z góry",
        "Down Payment + Upfront Payment": "Zaliczka + Płatność z góry",
        "First Recurring Payment": "Pierwsza płatność cykliczna",
        "Reverse From Partner": "Odwrócenie od Partnera",
        "Protected Payment": "Płatność chroniona",
        "Recurring Payment": "Płatność cykliczna",
        "Credee Fee + Down Payment": "Opłata Credee + Zaliczka",
        "Business Owner": "Właściciel firmy",
        "Customer": "Klient",
        "Service": "Praca",
        "Business": "Biznes",
        "Sub Industry": "Podprzemysł",
        "Start Date": "Data rozpoczęcia",
        "End Date": "Data końcowa",
        "Total Payment": "Całkowita płatność",
        "Payout Details": "Szczegóły wypłaty",
        "Payout Info": "Informacje o wypłacie",
        "Contract ID": "Identyfikator umowy",
        "Payment Amount": "Wielkość płatności",
        "Payment Status": "Status płatności",
        "Amount": "Kwota",
        "Arrival Date": "Data przybycia",
        'Sub Partner Name': 'Nazwa partnera podrzędnego',
        pending: 'aż do'
    },
    ja: {
        bank_business_info: "銀行はまだ追加されていません。ビジネス情報はまだ追加されていません",
        first_contract_date: "最初の契約日",
        last_contract_date: "最終契約日",
        completed: "完了しました",
        date_registered: '登録日',
        agent_name: 'エージェント名',
        email: 'Eメール',
        total_sales_made: '総売上高',
        added_by: 'によって追加',
        sale_date: 'セール日',
        avg_usage_rate: '平均使用率',
        agent_percentage: 'パーセンテージ',
        stripe_account_id: '登録状況',
        note: 'ノート',
        doctor_code: ' コード',
        doctor_title: '挨拶',
        doctor_first_name: 'ファーストネーム',
        doctor_last_name: '苗字',
        mobile: '携帯',
        ind_name: '業界',
        speciality_name: 'サブ産業',
        ind_is_guaranteed: '保証されたステータス',
        date_of_birth: '生年月日',
        practice_name: ' 名前',
        practice_address: ' 住所',
        total_number_of_contracts: '総契約数',
        contract_date: '契約日',
        avg_contract_financed_per_month: '月あたりの平均支払いプラン',
        avg_financed_amount: '月あたりの平均支払いプラン金額',
        avg_interest_rate: '平均金利',
        avg_down_payment: '平均頭金',
        avg_term: '平均学期',
        is_blocked: 'ブロックされました',
        bank_stripe_account_id: '銀行',
        share_form: '共有元',
        months: '月',
        guaranteed: '保護されています',
        non_guaranteed: '保護されていない',
        yes: "はい",
        no: "いいえ",
        business_owner_name: '事業主名',
        transaction_date: "取引日",
        payment_type: "払いの種類",
        commission_amount: "手数料金額",
        "Credee Fee + Upfront Payment": "クレジット料金 + 前払い",
        "Credee Fee + Down Payment + Upfront Payment": "クレジット料金 + 頭金 + 前払い",
        "Down Payment + Upfront Payment": "頭金 + 前払い",
        "First Recurring Payment": "最初 定期的な支払い",
        "Reverse From Partner": "パートナーからのリバース",
        "Protected Payment": "保護された支払い",
        "Recurring Payment": "定期支払い",
        "Credee Fee + Down Payment": "クレジット手数料 + 頭金",
        "Business Owner": "事業主",
        "Customer": "お客様",
        "Service": "サービス",
        "Business": "仕事",
        "Sub Industry": "サブ産業",
        "Start Date": "開始日",
        "End Date": "終了日",
        "Total Payment": "お支払い総額",
        "Payout Details": "支払いの詳細",
        "Payout Info": "支払い情報",
        "Contract ID": "契約ID",
        "Payment Amount": "支払金額",
        "Payment Status": "支払い状況",
        "Amount": "額",
        "Arrival Date": "到着日",
        'Sub Partner Name': 'サブパートナー名',
        pending: '保留中'
    }
}


export async function getZipCode(item: any) {
  const body = {
    addressObj: item,
  };
  let response = await httpApiCall({
    api: "add_address",
    type: "post",
    body,
    formtype: true
  });
  if (response && !response.is_error) {
    if (response && response.data && response.data.city_id) {
      return response.data;
    } else {
      return response;
    }
  } else {
    console.log(response && response.override_text);
  }
}


export function zipObjectCovert(item: any) {
    const desire_object: any = {};
    let temp: any
    desire_object.place_id = item?.place_id
    desire_object.item = item
    temp = item && item.address_components && item.address_components.find((inner: any) => inner.types.includes('postal_code') || inner.types.includes('plus_code'));
    temp = temp && temp.long_name;
    desire_object.zip = temp;
    desire_object.zipCode = temp;

    temp = item && item.address_components && item.address_components.find((inner: any) => inner.types.includes('locality'));
    temp = temp || item && item.address_components && item.address_components.find((inner: any) => inner.types.includes('administrative_area_level_2')) || item && item.address_components && item.address_components.find((inner: any) => inner.types.includes('postal_town')) || item && item.address_components && item.address_components.find((inner: any) => inner.types.includes('neighborhood')) || item && item.address_components && item.address_components.find((inner: any) => inner.types.includes('administrative_area_level_3'));

    temp = temp && temp.long_name;
    desire_object.city = temp;

    temp = item && item.address_components && item.address_components.find((inner: any) => inner.types.includes('administrative_area_level_1'));
    desire_object.state_name = temp && temp.long_name;
    desire_object.state_code = temp && temp.short_name;
    desire_object.State = temp && temp.short_name;


    temp = item && item.address_components && item.address_components.find((inner: any) => inner.types.includes('country'));
    desire_object.country_name = temp && temp.long_name;
    desire_object.country_code = temp && temp.short_name;

    if (item.geometry && item.geometry.location) {
        desire_object.latitude = item.geometry.location.lat();
        desire_object.longitude = item.geometry.location.lng();
    }
    return desire_object
}

export const getLanguageCookie = async () => {
    const name = "googtrans" + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        // tslint:disable:triple-equals
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};
// for clarity clck id send to every api
export const  get_clck = async () => {
  const decodedCookie = decodeURIComponent(document.cookie);

  const ca = decodedCookie.split(';');
  const d = ca.find(i => {
    let clck = i.includes('_clck');
    return clck;
  });
  const clck = d && d.split('=')
  return clck;
}

export const getCurrentTimezone = () => {
    let time = new Date().getTimezoneOffset();
    let hours = Math.abs(Math.trunc(time / 60));
    let minutes = ("0" + (time % 60)).slice(-2);
    let user_timezone = "";
    if (time > 0) {
        user_timezone = "-" + hours + minutes;
    } else {
        user_timezone = "+" + hours + minutes;
    }
    return user_timezone;
}

export const accessTokenLogin = async () => {
    

    const body = {
        access_token: getStorageValue("partnerToken")
    }
    const partnerData = await httpApiCall({ api: "access_token_login", type: "post", body });
    if (partnerData && !partnerData.is_error) {
        setLoginData(partnerData, '');
        store.dispatch(savePartnerData(partnerData));

    }
    return partnerData;
}

export const getProfileData = async () => {
    try {
      const token = getStorageValue("partnerToken");
      const body = {
        access_token: token,
      };
  
      const profile = await httpApiCall({
        api: "get_profile",
        type: "post",
        body,
      });
      console.log(profile);
      
      store.dispatch(savePartnerProfileData({ partner_events: profile.partner_events }));


      return profile;
    } catch (error) {
        console.error(error);        
    //   toastrService.showError(error);
    }
        
};

// export const createBinaryFile = async (data: any, sliceSize=512) => {
//     const byteCharacters = atob((data + '').split(',')[1]);
//     const byteArrays = [];
  
//     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
//       const slice = byteCharacters.slice(offset, offset + sliceSize);
  
//       const byteNumbers = new Array(slice.length);
//       for (let i = 0; i < slice.length; i++) {
//         byteNumbers[i] = slice.charCodeAt(i);
//       }
  
//       const byteArray = new Uint8Array(byteNumbers);
//       byteArrays.push(byteArray);
//     }
      
//     const blob = new Blob(byteArrays, {type: 'image/png'});
//     return blob;
// } 

export const exportHeaderForBusiness = async (selectedTabs: any) => {
    return {
    date_registered: getLanguage(
      "date_registered",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    doctor_code:
      getLanguage(
        "Business Owner",
        selectedTabs && selectedTabs["language_preffered"]
      ) +
      getLanguage(
        "doctor_code",
        selectedTabs && selectedTabs["language_preffered"]
      ),
    doctor_title: getLanguage(
      "doctor_title",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    doctor_first_name: getLanguage(
      "doctor_first_name",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    doctor_last_name: getLanguage(
      "doctor_last_name",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    doctor_email: getLanguage(
      "email",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    doctor_mobile: getLanguage(
      "mobile",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    ind_name: getLanguage(
      "ind_name",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    speciality_name: getLanguage(
      "speciality_name",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    ind_is_guaranteed: getLanguage(
      "ind_is_guaranteed",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    date_of_birth: getLanguage(
      "date_of_birth",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    practice_email:
      getLanguage(
        "Business",
        selectedTabs && selectedTabs["language_preffered"]
      ) +
      getLanguage(
        "email",
        selectedTabs && selectedTabs["language_preffered"]
      ),
    practice_mobile:
      getLanguage(
        "Business",
        selectedTabs && selectedTabs["language_preffered"]
      ) +
      getLanguage(
        "mobile",
        selectedTabs && selectedTabs["language_preffered"]
      ),
    practice_name:
      getLanguage(
        "Business",
        selectedTabs && selectedTabs["language_preffered"]
      ) +
      getLanguage(
        "practice_name",
        selectedTabs && selectedTabs["language_preffered"]
      ),
    practice_address:
      getLanguage(
        "Business",
        selectedTabs && selectedTabs["language_preffered"]
      ) +
      getLanguage(
        "practice_address",
        selectedTabs && selectedTabs["language_preffered"]
      ),
    total_number_of_contracts: getLanguage(
      "total_number_of_contracts",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    total_earning: getLanguage(
      "total_earning",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    total_upcoming_earnings: getLanguage(
      "total_upcoming_earnings",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    added_by: getLanguage(
      "added_by",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    contract_date: getLanguage(
      "contract_date",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    avg_contract_financed_per_month: getLanguage(
      "avg_contract_financed_per_month",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    avg_financed_amount: getLanguage(
      "avg_financed_amount",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    avg_interest_rate: getLanguage(
      "avg_interest_rate",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    avg_down_payment: getLanguage(
      "avg_down_payment",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    avg_term: getLanguage(
      "avg_term",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    is_blocked: getLanguage(
      "is_blocked",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    stripe_account_id: getLanguage(
      "stripe_account_id",
      selectedTabs && selectedTabs["language_preffered"]
    ),
    note: getLanguage(
      "note",
      selectedTabs && selectedTabs["language_preffered"]
    )}
}

const exportType = {
    XLSX: "XLSX",
    CSV: "CSV",
};

export const exportCSVBusiness: any = async (a: any, selectedTabs: any, partnerData: any, listData: any, currencyLogo: any) => {
    let list: any = [];
    let dataList: any = [];
    let headers: any = [];
    list[0] = await exportHeaderForBusiness(selectedTabs);
    headers = Object.values(list[0]);
    if (
      partnerData &&
      partnerData.partner_profile &&
      partnerData.partner_profile[0]["can_provide_doctor_share"]
    ) {
      list[0]["partner_share_from_doctor"] =
        "Share from " +
        getLanguage(
          "Business",
          selectedTabs && selectedTabs["language_preffered"]
        );
    }

    let filter_doctors: any = listData;
    for (var i = 0; i < filter_doctors.length; i++) {
      list[i + 1] = {};
      list[i + 1].date_registered = new Date(
        `${filter_doctors[i]["date_registered"]}`
      ).toLocaleDateString();
      list[i + 1].doctor_code = filter_doctors[i]["referral_code"];
      list[i + 1].doctor_title = filter_doctors[i]["title"] || "-";
      list[i + 1].doctor_first_name = filter_doctors[i]["doctor_first_name"];
      list[i + 1].doctor_last_name = filter_doctors[i]["doctor_last_name"];
      list[i + 1].doctor_email = filter_doctors[i]["doctor_email"];
      list[i + 1].doctor_mobile =
        (filter_doctors[i]["doctor_mobile"]
          ? filter_doctors[i]["doctor_mobile_country_code"]
          : "") + '-' + filter_doctors[i]["doctor_mobile"];

      list[i + 1].ind_name = filter_doctors[i]["ind_name"];
      list[i + 1].speciality_name = filter_doctors[i]["speciality_name"];
      list[i + 1].ind_is_guaranteed = filter_doctors[i]["ind_is_guaranteed"]
        ? getLanguage(
            "guaranteed",
            selectedTabs && selectedTabs["language_preffered"]
          )
        : getLanguage(
            "non_guaranteed",
            selectedTabs && selectedTabs["language_preffered"]
          );
      list[i + 1].date_of_birth =
        utc_to_local(filter_doctors[i]["date_of_birth"]) || "-";
      list[i + 1].practice_email = filter_doctors[i]["practice_email"] || "-";
      list[i + 1].practice_mobile =
        (filter_doctors[i]["practice_mobile"] &&
        filter_doctors[i]["practice_mobile_country_code"]
          ? filter_doctors[i]["practice_mobile_country_code"] +
            filter_doctors[i]["practice_mobile"]
          : "-") || "-";
      list[i + 1].practice_name = filter_doctors[i]["practice_name"] || "-";

      list[i + 1].practice_address =
        filter_doctors[i]["practice_address"] || "-";
      list[i + 1].total_number_of_contracts =
        filter_doctors[i]["total_financed_contract"] || 0;
      list[i + 1].total_earning =
        filter_doctors[i]["total_earning"] || 0;
      list[i + 1].total_upcoming_earnings =
        filter_doctors[i]["total_upcoming_earnings"] || 0;

      list[i + 1].added_by =
        filter_doctors[i]["partner_name"] +
        " - " +
        filter_doctors[i]["partner_referral_code"];

      list[i + 1].contract_date =
        getLanguage(
          "first_contract_date",
          selectedTabs && selectedTabs["language_preffered"]
        ) +
        ":" +
        (filter_doctors[i]["first_contract_date"]
          ? utc_to_local(filter_doctors[i]["first_contract_date"])
          : "N/A") +
        " " +
        getLanguage(
          "last_contract_date",
          selectedTabs && selectedTabs["language_preffered"]
        ) +
        ":" +
        (filter_doctors[i]["last_contract_date"]
          ? utc_to_local(filter_doctors[i]["last_contract_date"])
          : "N/A");
      list[i + 1].avg_contract_financed_per_month = financedAvg(
        filter_doctors[i]["total_financed_contract"],
        filter_doctors[i]["date_registered"]
      );
      list[i + 1].avg_financed_amount =
        currencyLogo &&
        currencyLogo["display_logo"] +
          financedAvg(
            filter_doctors[i]["total_financed_amount"],
            filter_doctors[i]["date_registered"]
          );
      list[i + 1].avg_interest_rate =
        getAvgInterestRate(
          filter_doctors[i]["total_interest_rate"],
          filter_doctors[i]["total_financed_contract"]
        ) + "%";
      list[i + 1].avg_down_payment =
        currencyLogo &&
        currencyLogo["display_logo"] +
          getAvgInterestRate(
            filter_doctors[i]["total_downpayment_amount"],
            filter_doctors[i]["total_financed_contract"]
          );
      list[i + 1].avg_term =
        getAvgInterestRate(
          filter_doctors[i]["total_number_of_payments"],
          filter_doctors[i]["total_financed_contract"]
        ) +
        getLanguage(
          "months",
          selectedTabs && selectedTabs["language_preffered"]
        );
      list[i + 1].is_blocked = filter_doctors[i]["is_blocked"]
        ? getLanguage("yes", selectedTabs && selectedTabs["language_preffered"])
        : getLanguage("no", selectedTabs && selectedTabs["language_preffered"]);
      list[i + 1].stripe_account_id =
        filter_doctors[i]["stripe_account_id"] != null &&
        filter_doctors[i]["stripe_account_id"] != "null"
          ? getLanguage(
              "yes",
              selectedTabs && selectedTabs["language_preffered"]
            )
          : getLanguage(
              "no",
              selectedTabs && selectedTabs["language_preffered"]
            );
      list[i + 1].note = filter_doctors[i]["note"] || "-";
      if (
        partnerData &&
        partnerData.partner_profile &&
        partnerData.partner_profile[0]["can_provide_doctor_share"]
      ) {
        list[i + 1]["partner_share_from_doctor"] = filter_doctors[i][
          "partner_share_from_doctor"
        ]
          ? filter_doctors[i]["partner_share_from_doctor"] + "%"
          : "-";
      }
      // if (filter_doctors && filter_doctors[i] && filter_doctors[i]["zip"]) {
      //   filter_doctors[i]["practice_address"] =
      //     filter_doctors[i]["practice_address"] + ", " + filter_doctors[i]["zip"];
      // } else {
      //   if (filter_doctors && filter_doctors[i]) {
      //     filter_doctors[i]["practice_address"] = "-";
      //   }
      // }
      // if (filter_doctors && filter_doctors[i] && filter_doctors[i]["city"]) {
      //   filter_doctors[i]["practice_address"] =
      //     filter_doctors[i]["practice_address"] +
      //     ", " +
      //     filter_doctors[i]["city"];
      // } else {
      //   if (filter_doctors && filter_doctors[i]) {
      //     filter_doctors[i]["practice_address"] = "-";
      //   }
      // }
      // if (
      //   filter_doctors &&
      //   filter_doctors[i] &&
      //   filter_doctors[i]["state_name"]
      // ) {
      //   filter_doctors[i]["practice_address"] =
      //     filter_doctors[i]["practice_address"] +
      //     ", " +
      //     filter_doctors[i]["state_name"];
      // } else {
      //   if (filter_doctors && filter_doctors[i]) {
      //     filter_doctors[i]["practice_address"] = "-";
      //   }
      // }
      dataList.push(Object.values(list[i + 1]));
    }


    if (a == exportType.CSV) {
        return {
            headers,
            dataList,
          }
    //   setexportCSVData({
    //     headers: headers,
    //     data: dataList,
    //   });
    //   setTimeout(() => {
    //     const link: any = document.getElementById("custom-hidden");
    //     link.setAttribute("download", "Sub-partner" + ".csv");
    //     link.click();
    //   }, 1000);
    }
    if (a == exportType.XLSX) {
      dataList.unshift(headers);
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(dataList);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      // Save workbook as XLSX file
      XLSX.writeFile(workbook, "Businesses" + ".xlsx");
    }
  };


export const getMd5Hash = (text: string): string => {
  try {
    if (typeof text !== 'string' || !text.trim()) {
      return text;
    }

    return md5(text);
  } catch (error) {
    console.error('MD5 hash failed:', error);
    return text;
  }
};
export const handleInputSpace = (event : any) => {
  if (event.code === 'Space') {
    event.target.value = event.target.value.trim();
    event.preventDefault();
  }
};

